import DisciplinesCatalogPage from "./DisciplinesCatalogPage";

export default DisciplinesCatalogPage;